import _get from 'lodash/get';
import { handleActions } from 'redux-actions';
import update from 'immutability-helper';
import {
  getTakenSeriesProcessing,
  getTakenSeriesSuccess,
  seriesCompleted,
  seriesCompletedResourcesSaved,
  lastViewedResourceSaved,
  resourceProgressSaved,
  seriesCustomQuestionSaved,
  seriesAssessmentSaved,
  setGuestWarningModalState,
} from './actions';

export const initialState = {
  allSeries: [],
  takenSeries: {},
  takenSeriesProcessing: false,
  guestWarningModal: { show: false },
};

const seriesReducer = handleActions(
  {
    [seriesCompleted](
      state,
      {
        payload: { completedResourcesIds, id },
      },
    ) {
      return update(state, {
        takenSeries: {
          $merge: {
            [id]: {
              ...state.takenSeries[id],
              completedResourcesIds,
              completedAt: new Date(),
              completed: true,
            },
          },
        },
      });
    },
    [getTakenSeriesProcessing](state, action) {
      return update(state, {
        takenSeriesProcessing: { $set: action.payload },
      });
    },
    [seriesCompletedResourcesSaved](
      state,
      {
        payload: { completedResourcesIds, id, resourceId, completed },
      },
    ) {
      const currentLastViewed =
        state.takenSeries[id] && state.takenSeries[id].lastViewedResource;
      const lastViewedResource = currentLastViewed && {
        lastViewedResource: {
          ...currentLastViewed,
          completed,
        },
      };

      const currentResourcesProgress =
        state.takenSeries[id] && state.takenSeries[id].resourcesProgress;
      const resourcesProgress = currentResourcesProgress && {
        ...currentResourcesProgress,
        [resourceId]: null,
      };

      return update(state, {
        takenSeries: {
          $merge: {
            [id]: {
              ...state.takenSeries[id],
              completedResourcesIds,
              lastViewedResource,
              resourcesProgress,
              completed: false,
            },
          },
        },
      });
    },
    [lastViewedResourceSaved](
      state,
      {
        payload: { id, resourceId, completed },
      },
    ) {
      return update(state, {
        takenSeries: {
          $merge: {
            [id]: {
              ...state.takenSeries[id],
              lastViewedResource: {
                id: resourceId,
                completed,
              },
            },
          },
        },
      });
    },
    [resourceProgressSaved](
      state,
      {
        payload: { id, resourceId, seconds },
      },
    ) {
      const currentResourcesProgress =
        state.takenSeries[id] && state.takenSeries[id].resourcesProgress;

      return update(state, {
        takenSeries: {
          $merge: {
            [id]: {
              ...state.takenSeries[id],
              resourcesProgress: {
                ...currentResourcesProgress,
                [resourceId]: seconds,
              },
            },
          },
        },
      });
    },
    [seriesAssessmentSaved](state, action) {
      const { id, updatedCompletedAssessments } = action.payload;
      return update(state, {
        takenSeries: {
          $merge: {
            [id]: {
              ...state.takenSeries[id],
              completedAssessments: updatedCompletedAssessments,
            },
          },
        },
      });
    },
    [getTakenSeriesSuccess](state, action) {
      return update(state, {
        takenSeries: { $set: action.payload.takenSeries },
        takenSeriesProcessing: { $set: false },
        ...(action.payload.allSeries && {
          allSeries: { $set: action.payload.allSeries },
        }),
      });
    },
    [seriesCustomQuestionSaved](state, action) {
      const { id, question } = action.payload;
      const taken = state.takenSeries[id];
      return update(state, {
        takenSeries: {
          $merge: {
            [id]: {
              ...state.takenSeries[id],
              seriesCustomQuestions: {
                ..._get(taken, 'seriesCustomQuestions'),
                [question.name]: question.value,
              },
            },
          },
        },
      });
    },
    [setGuestWarningModalState](state, action) {
      return update(state, {
        guestWarningModal: { $set: action.payload },
      });
    },
  },
  initialState,
);

export default seriesReducer;
